import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Grid,
  Card,
  CardContent,
  Button,
} from '@mui/material';
import {
  School,
  Code,
  Psychology,
  Language,
  Science,
  Calculate,
  Business,
  History,
  Book,
  Biotech,
  Public,
  TrendingUp,
  SportsSoccer,
  Computer,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Education = () => {
  const navigate = useNavigate();

  const educationTopics = [
    {
      icon: <Code />,
      title: 'Programming',
      description: 'Learn coding concepts, algorithms, and development practices',
      color: '#2196f3',
      category: 'programming',
    },
    {
      icon: <Psychology />,
      title: 'AI & Machine Learning',
      description: 'Artificial Intelligence, ML algorithms, and data science',
      color: '#9c27b0',
      category: 'programming',
      subcategory: 'AI',
    },
    {
      icon: <Language />,
      title: 'Languages',
      description: 'Foreign language learning and linguistics',
      color: '#4caf50',
      category: 'programming',
    },
    {
      icon: <Science />,
      title: 'Physics',
      description: 'Physics concepts, theories, and practical applications',
      color: '#ff9800',
      category: 'programming',
    },
    {
      icon: <Calculate />,
      title: 'Mathematics',
      description: 'Mathematical concepts from basic to advanced levels',
      color: '#f44336',
      category: 'programming',
      subcategory: 'algorithms',
    },
    {
      icon: <Business />,
      title: 'Entrepreneurship',
      description: 'Business concepts, startup strategies, and leadership',
      color: '#795548',
      category: 'personal skills',
    },
    {
      icon: <History />,
      title: 'History',
      description: 'Historical events, civilizations, and cultural studies',
      color: '#607d8b',
      category: 'history',
    },
    {
      icon: <Book />,
      title: 'Literature',
      description: 'Literary works, analysis, and creative writing',
      color: '#e91e63',
      category: 'literature',
    },
    {
      icon: <Biotech />,
      title: 'Biology',
      description: 'Life sciences, anatomy, and biological processes',
      color: '#4caf50',
      category: 'biology',
    },
    {
      icon: <Public />,
      title: 'Geography',
      description: 'World geography, cultures, and environmental studies',
      color: '#00bcd4',
      category: 'geography',
    },
    {
      icon: <TrendingUp />,
      title: 'Finance',
      description: 'Financial literacy, investment, and economic principles',
      color: '#ffc107',
      category: 'finance',
    },
    {
      icon: <SportsSoccer />,
      title: 'Sports & Fitness',
      description: 'Athletic training, sports strategies, and health',
      color: '#f44336',
      category: 'sport',
    },
    {
      icon: <Computer />,
      title: 'Computer Science',
      description: 'CS fundamentals, data structures, and software engineering',
      color: '#3f51b5',
      category: 'programming',
      subcategory: 'JS',
    },
  ];

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* Header */}
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <School sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
          <Typography
            variant="h3"
            gutterBottom
            sx={{
              fontWeight: 600,
              color: 'primary.main',
            }}
          >
            Education Hub
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
            Explore educational content across various topics
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Learn English while exploring diverse educational subjects
          </Typography>
        </Box>

        {/* Topics Grid */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {educationTopics.map((topic, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4,
                  },
                  border: `2px solid ${topic.color}`,
                  position: 'relative',
                  overflow: 'visible',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: -15,
                    left: 20,
                    width: 50,
                    height: 50,
                    borderRadius: '50%',
                    backgroundColor: topic.color,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    boxShadow: 2,
                  }}
                >
                  {topic.icon}
                </Box>
                <CardContent sx={{ pt: 4, textAlign: 'center' }}>
                  <Typography variant="h6" fontWeight="600" gutterBottom sx={{ mt: 1 }}>
                    {topic.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {topic.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Education;
